import React from 'react'

function UpdateProfilePage() {
  return (
    <div>
        <h1>Update Profile Page</h1>
        < updateProfileForm />
    </div>
  )
}

export default UpdateProfilePage